import React, { useState, useEffect } from "react";
import Logo from "../assets/mainlogo.png";
import Fireworks from "../assets/fireworks.mp4";
import Instagram from "../assets/Instagram";
import Facebook from "../assets/Facebook";
import Tiktok from "../assets/Tiktok";
import TagManager from "react-gtm-module";

const Business = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [isLaptopMessageShown, setIsLaptopMessageShown] = useState(false);
  const gtmId = "GTM-T4QRDGLB";
  const initializeTagManager = () => {
    TagManager.initialize({ gtmId });
  };

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    const isAndroid = /android/i.test(userAgent);
    initializeTagManager(); 
    setIsMobile(isIOS || isAndroid);

    if (!isIOS && !isAndroid) {
      setIsLaptopMessageShown(true);
    }
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        position: "relative",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div className="navbar">
        <div className="nav-logo-div">
          <img alt="TheBooker Logo" src={Logo} />
          <p>TheBooker</p>
        </div>
      </div>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            textAlign: "center",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <video
            playsInline
            autoPlay
            muted
            loop
            style={{ objectFit: "contain", width: 400 }}
          >
            <source src={Fireworks} type="video/mp4"></source>
          </video>
          <h1
            style={{
              fontFamily: "Hurme-Bold",
              color: "#008a80",
              padding: "0 10px",
            }}
          >
            Glad to Have You on Board!
          </h1>
          <p
            style={{
              fontFamily: "Hurme-Light",
              marginTop: 10,
              padding: "0 10px",
            }}
          >
            Thank you for subscribing to our services. We’re excited to have you
            with us and look forward to supporting your business.
            <br />
            {isMobile ? (
              <span
                style={{
                  fontFamily: "Hurme-Light",
                  marginTop: 10,
                  padding: "0 10px",
                }}
              >
                Why not explore our app while you're here?
              </span>
            ) : (
              ""
            )}
          </p>
          {isMobile ? (
            <div
              onClick={() => window.location.replace("/store")}
              className="subscribe-btn"
              style={{ marginTop: 25 }}
            >
              Dive Now
            </div>
          ) : (
            <div
              onClick={() => window.location.replace("/")}
              className="subscribe-btn"
              style={{ marginTop: 25 }}
            >
              Back To Website
            </div>
          )}
        </div>
      </div>
      <div className="footer-thanks-main">
        <div
          className="footer-thanks"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <a
              href="https://www.instagram.com/thebookerapp?igsh=OWEwYXg5YjQ0NXQx"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Instagram width={30} height={30} />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61555465270361&mibextid=ZbWKwL"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Facebook width={30} height={30} />
            </a>
            <a
              href="https://www.tiktok.com/@thebooker.app?_t=8laJs404Hl2&_r=1"
              target="_blank"
              rel="noreferrer"
              style={{ marginRight: "15px" }}
            >
              <Tiktok width={30} height={30} />
            </a>
          </div>
          <p>TheBooker App. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Business;
